import { ComponentType } from '@angular/cdk/portal';
import { inject, Injectable, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';


export const ACTION_MODAL_PARAMS: MatDialogConfig = {
    width: '400px',
    maxWidth: 'calc(100% - 2px)',
    ariaLabelledBy: 'modal-head',
};

/**
 * Service for working with Angular Material modal windows
 */
@Injectable()
export class MatDialogService {
    readonly #dialog: MatDialog = inject(MatDialog);

    /**
     * Open modal window
     * @param componentOrTemplateRef - Content Component
     * @param config - parameters
     */
    public open<T, D = unknown, R = unknown>(
        componentOrTemplateRef: ComponentType<T> | TemplateRef<T>,
        config: MatDialogConfig<D> = {},
    ): MatDialogRef<T, R> {
        const activeElement: HTMLElement = document.activeElement as HTMLElement;

        if (activeElement) {
            activeElement.blur();
        }

        // prevent "dialog exists" error
        if (config.id && this.getDialogById(config.id)) {
            return undefined;
        }

        return this.#dialog.open(componentOrTemplateRef, { ...ACTION_MODAL_PARAMS, ...config });
    }

    /**
     * Get modal window object by ID
     * @param id - modal window ID
     */
    public getDialogById(id: string): MatDialogRef<unknown> | undefined {
        return this.#dialog.getDialogById(id);
    }

    /**
     * Close modal by ID
     * @param id - modal window ID
     * @param opt_param - param close
     */
    public close(id: string, opt_param?: unknown): void {
        const ref: MatDialogRef<unknown> = this.#dialog.getDialogById(id);

        if (ref) {
            ref.close(opt_param || null);
        }
    }
}
